import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEditor } from "../../hooks/EditorProvider";
import { DraggableComponentTypes, } from "../../types/draggable";
import DraggableButton from "./draggableComponents/DraggableButton";
import DraggableContainer from "./draggableComponents/DraggableContainer";
import DraggableDiv from "./draggableComponents/DraggableDiv";
import DraggableForm from "./draggableComponents/DraggableForm";
import DraggableGrid from "./draggableComponents/DraggableGrid";
import DraggableGridItem from "./draggableComponents/DraggableGridItem";
import DraggableImage from "./draggableComponents/DraggableImage";
import DraggableLink from "./draggableComponents/DraggableLink";
import DraggableList from "./draggableComponents/DraggableList";
import DraggableSvg from "./draggableComponents/DraggableSvg";
import DraggableText from "./draggableComponents/DraggableText";
import DraggableTitle from "./draggableComponents/DraggableTitle";
import DraggableListItem from "./draggableComponents/DraggableListItem";
import DraggableNavbarHorizontal from "./draggableComponents/DraggableNavbarHorizontal";
import DraggableHtml from "./draggableComponents/DraggableHtml";
import DraggableIcon from "./draggableComponents/DraggableIcon";
import DraggableNavbarVertical from "./draggableComponents/DraggableNavbarVertical";
const DraggableComponent = ({ item, elementId, }) => {
    const { setDragActive, dragOverComponent, mode, setDragContextMenu, iframeMount, } = useEditor();
    const isEditor = mode !== "production";
    const handleDragStart = (e) => {
        setDragActive(true);
        e.dataTransfer.setData("editor-component-drag-type", item.type);
        e.dataTransfer.setData("editor-component-drag-item", JSON.stringify(item));
    };
    const handleDragOver = (e) => {
        dragOverComponent.current = item.id;
    };
    const handleDragLeave = (e) => {
        dragOverComponent.current = null;
    };
    const handleRightClick = (e) => {
        if (e.type === "contextmenu") {
            e.preventDefault();
            if (e.target?.getAttribute("editor-key") === item.id) {
                if (typeof e.target?.click === "function") {
                    e.target?.click();
                }
                setDragContextMenu({
                    x: e.clientX,
                    y: e.clientY + iframeMount.scrollTop,
                    elementId,
                    item,
                });
            }
        }
    };
    const defaultDragProps = isEditor
        ? {
            draggable: true,
            onDragStart: handleDragStart,
            onDragOver: handleDragOver,
            onDragLeave: handleDragLeave,
        }
        : {};
    const defaultRightClickProps = isEditor
        ? {
            onContextMenu: handleRightClick,
        }
        : {};
    switch (item.type) {
        case DraggableComponentTypes.Text:
            return (_jsx(DraggableText, { item: item, ...defaultDragProps, ...defaultRightClickProps }));
        case DraggableComponentTypes.Title:
            return (_jsx(DraggableTitle, { item: item, ...defaultDragProps, ...defaultRightClickProps }));
        case DraggableComponentTypes.Div:
            return (_jsx(DraggableDiv, { ...item, ...defaultRightClickProps, elementId: elementId }));
        case DraggableComponentTypes.Container:
            return (_jsx(DraggableContainer, { ...item, ...defaultRightClickProps, elementId: elementId }));
        case DraggableComponentTypes.Grid:
            return (_jsx(DraggableGrid, { ...item, ...defaultRightClickProps, elementId: elementId }));
        case DraggableComponentTypes.GridItem:
            return (_jsx(DraggableGridItem, { ...item, ...defaultRightClickProps, elementId: elementId }));
        case DraggableComponentTypes.Image:
            return (_jsx(DraggableImage, { item: item, ...defaultDragProps, ...defaultRightClickProps }));
        case DraggableComponentTypes.Link:
            return (_jsx(DraggableLink, { item: item, ...defaultDragProps, ...defaultRightClickProps }));
        case DraggableComponentTypes.Button:
            return (_jsx(DraggableButton, { item: item, ...defaultDragProps, ...defaultRightClickProps }));
        case DraggableComponentTypes.Form:
            return (_jsx(DraggableForm, { item: item, ...defaultDragProps, ...defaultRightClickProps }));
        case DraggableComponentTypes.Svg:
            return (_jsx(DraggableSvg, { item: item, ...defaultDragProps, ...defaultRightClickProps }));
        case DraggableComponentTypes.Icon:
            return (_jsx(DraggableIcon, { item: item, ...defaultDragProps, ...defaultRightClickProps }));
        case DraggableComponentTypes.List:
            return _jsx(DraggableList, { item: item, elementId: elementId });
        case DraggableComponentTypes.Navbar:
            return (_jsx(DraggableNavbarHorizontal, { item: item, ...defaultRightClickProps }));
        case DraggableComponentTypes.NavbarVertical:
            return (_jsx(DraggableNavbarVertical, { item: item, ...defaultRightClickProps }));
        case DraggableComponentTypes.ListItem:
            return (_jsx(DraggableListItem, { item: item, elementId: elementId, ...defaultRightClickProps }));
        case DraggableComponentTypes.Html:
            return (_jsx(DraggableHtml, { item: item, elementId: elementId, ...defaultRightClickProps }));
        default:
            return _jsxs("div", { children: ["Not found ", item.type] });
    }
};
export default DraggableComponent;
//# sourceMappingURL=DraggableComponent.js.map